export default __webpack_public_path__ + "static/media/CR_intro_video.cc65706f.mp4";